// Маска и валидация телефона для российских номеров: +7 (___) ___-__-__

// Приводит любой ввод к маске +7 (XXX) XXX-XX-XX по мере набора.
export function formatPhone(raw) {
  let digits = String(raw).replace(/\D/g, "");

  // Нормализуем ведущую 8 или 7 к коду 7.
  if (digits.startsWith("8")) digits = "7" + digits.slice(1);
  if (!digits.startsWith("7")) digits = "7" + digits;
  digits = digits.slice(0, 11); // 7 + 10 цифр

  const d = digits.slice(1); // 10 цифр после кода страны
  let out = "+7";
  if (d.length > 0) out += " (" + d.slice(0, 3);
  if (d.length >= 3) out += ")";
  if (d.length > 3) out += " " + d.slice(3, 6);
  if (d.length > 6) out += "-" + d.slice(6, 8);
  if (d.length > 8) out += "-" + d.slice(8, 10);
  return out;
}

// true, если номер полный (11 цифр: 7 + 10).
export function isPhoneValid(value) {
  return String(value).replace(/\D/g, "").length === 11;
}

// Имя: минимум 2 символа, только буквы/пробел/дефис (RU/EN).
export function isNameValid(value) {
  const v = String(value).trim();
  return v.length >= 2 && /^[А-Яа-яЁёA-Za-z\s-]+$/.test(v);
}
